module.exports = __webpack_public_path__ + "static/img/content_bg.085af308.png";